function scrollDown() {
  const win_width = window.innerWidth;
  const top = window.scrollY;
  const headerEl = document.getElementById("header");
  if (win_width > 640) {
    console.log("scrollDown function called");
    if (top > 160) {
      headerEl.classList.add("scroll");
    } else {
      headerEl.classList.remove("scroll");
    }
  }
}
const fondoSticky = document.querySelector(".games__bg");
const sectionConFondo = document.getElementById("games");
//const scrollIndicator = document.getElementById("scrollIndicator");

let isSticky = true;
window.addEventListener("scroll", () => {
  const scrollY = window.scrollY;
  const sectionTop = sectionConFondo.offsetTop;
  const sectionBottom = sectionTop + sectionConFondo.offsetHeight;
  const windowHeight = window.innerHeight;

  // Actualizar indicador de scroll
  //scrollIndicator.textContent = `Scroll: ${Math.round(scrollY)}px`;

  // Lógica del fondo sticky
  if (scrollY >= sectionTop && scrollY <= sectionBottom - windowHeight) {
    // Dentro de la sección - fondo fijo
    if (!isSticky) {
      fondoSticky.style.position = "fixed";
      fondoSticky.style.top = "0";
      fondoSticky.style.transform = "translateY(0)";
      isSticky = true;
    }
  } else if (scrollY > sectionBottom - windowHeight) {
    // Después de la sección - fondo se mueve con la sección
    if (isSticky) {
      fondoSticky.style.position = "absolute";
      fondoSticky.style.top = `${sectionBottom - sectionTop - windowHeight}px`;
      isSticky = false;
    }
  } else {
    // Antes de la sección - fondo oculto o fuera de vista
    if (isSticky) {
      fondoSticky.style.position = "absolute";
      fondoSticky.style.top = "0";
      isSticky = false;
    }
  }
});
window.dispatchEvent(new Event("scroll"));
scrollDown();
window.addEventListener("scroll", function (e) {
  scrollDown();
});